function lsGet(key: string): string | undefined {
  if (typeof window === "undefined") return undefined;
  return localStorage.getItem(key) ?? undefined;
}

function lsSet(key: string, value: string): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(key, value);
}

function lsRemove(key: string): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(key);
}

// App
const sidebarStatusKey = "sidebar_status";
export const getSidebarStatus = () => lsGet(sidebarStatusKey);
export const setSidebarStatus = (sidebarStatus: string) =>
  lsSet(sidebarStatusKey, sidebarStatus);

const languageKey = "language";
export const getLanguage = () => lsGet(languageKey);
export const setLanguage = (language: string) => lsSet(languageKey, language);

const sizeKey = "size";
export const getSize = () => lsGet(sizeKey);
export const setSize = (size: string) => lsSet(sizeKey, size);

// User
const tokenKey = "AndyProjects20210203";
export const getToken = () => lsGet(tokenKey);
export const setToken = (token: string) => lsSet(tokenKey, token);
export const removeToken = () => lsRemove(tokenKey);

// QuestionBank Token
const qbTokenKey = "questionBankAccessToken";
export const getQBToken = () => lsGet(qbTokenKey);
export const setQBToken = (token: string) => lsSet(qbTokenKey, token);
export const removeQBToken = () => lsRemove(qbTokenKey);

// Reading Project（与 index.vue 中 setReadingProject 写入结构一致）
export interface ReadingProjectLocalCache {
  wordReadingProjectId: string;
  readingType: string;
  selectedWords: any[];
}

const readingProjectKey = "ReadingProject";
export const getReadingProject = (): ReadingProjectLocalCache | null => {
  const data = lsGet(readingProjectKey);
  if (!data) return null;
  try {
    const parsed = JSON.parse(data) as ReadingProjectLocalCache;
    if (
      parsed &&
      typeof parsed.wordReadingProjectId === "string" &&
      typeof parsed.readingType === "string" &&
      Array.isArray(parsed.selectedWords)
    ) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
};
export const setReadingProject = (project: ReadingProjectLocalCache) =>
  lsSet(readingProjectKey, JSON.stringify(project));
export const removeReadingProject = () => lsRemove(readingProjectKey);
